import { call, put, takeEvery } from 'redux-saga/effects'
import * as bangLuongActions from '@redux/ducks/bangLuong.Ducks'
import * as bangLuongApi from '@apis/bangLuong/bangLuong.Api'
import * as kyLuongApi from '@apis/bangLuong/kyLuong.Api'
import * as tongHopApi from '@apis/bangLuong/tongHop.Api'
import * as giaoNhanApi from '@apis/bangLuong/giaoNhan.Api'

// Bảng lương
function* fetchDanhSachBangLuong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof bangLuongApi.locBangLuong> = yield call(bangLuongApi.locBangLuong, queryStr)
    yield put(bangLuongActions.layDanhSachBangLuongThanhCong(res))
  } catch (error) {
    yield put(bangLuongActions.layDanhSachBangLuongThatBai(error))
  }
}

// Kỳ lương
function* fetchDanhSachKyLuong({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof kyLuongApi.layDanhSachKyLuong> = yield call(kyLuongApi.layDanhSachKyLuong, queryStr)
    yield put(bangLuongActions.layDanhSachKyLuongThanhCong(res))
  } catch (error) {
    yield put(bangLuongActions.layDanhSachKyLuongThatBai(error))
  }
}

// Tổng hợp
function* fetchDanhSachTongHop({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof tongHopApi.layBaoCaoTongQuyLuong> = yield call(tongHopApi.layBaoCaoTongQuyLuong, queryStr)
    yield put(bangLuongActions.layDanhSachTongHopThanhCong(res))
  } catch (error) {
    yield put(bangLuongActions.layDanhSachTongHopThatBai(error))
  }
}

// Giao nhận
function* fetchDanhSachGiaoNhan({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    // Giao nhận requires payslipId, using a placeholder for now
    const res: ReturnType<typeof giaoNhanApi.layLichSuGiaoNhan> = yield call(giaoNhanApi.layLichSuGiaoNhan, params.payslipId || 0, queryStr)
    yield put(bangLuongActions.layDanhSachGiaoNhanThanhCong(res))
  } catch (error) {
    yield put(bangLuongActions.layDanhSachGiaoNhanThatBai(error))
  }
}

export default function* watchBangLuong() {
  yield takeEvery(bangLuongActions.layDanhSachBangLuong.toString(), fetchDanhSachBangLuong)
  yield takeEvery(bangLuongActions.layDanhSachKyLuong.toString(), fetchDanhSachKyLuong)
  yield takeEvery(bangLuongActions.layDanhSachTongHop.toString(), fetchDanhSachTongHop)
  yield takeEvery(bangLuongActions.layDanhSachGiaoNhan.toString(), fetchDanhSachGiaoNhan)
}

